export class InputText {
    format?:string;
    showLabel?:boolean;
    btnEnable?:boolean;
    bold?:boolean;
    textRight?:boolean;
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    submitted?: boolean;
    validatorAlert?: boolean;
}

